import { useEffect, useState } from "react"
import MessageContainer from "../../container/MessageContainer"
import MessageNewsContainer from "../../container/MessageNewsContainer"
import { SectorAutomationContainer } from "../../container/SectorAutomationContainer"
import SendMagicLinkContainer from "../../container/SendMagicLinkContainer"
import { SendTermsOfUseContainer } from "../../container/SendTermsOfUseContainer"
import clickOutSideHook from "../../core/utils/hooks/listen-click-outside"
import { DropDownOptionsButton } from "../DropDownOptions"
import { exportUsersProject } from "../../core/utils/exports"
import { useSelector } from "react-redux"
import { SendFormContainer } from "../../container/SendFormContainer"
import ModalAlert from "../ModalAlert"
import { getIds } from "../../core/utils/getIds"
import { AssistanceRecordContainer } from "../../container/AssistanceRecordContainer";

export const ActionsButtons = ({
  countUsers,
  selectedsUsers,
  selectedCardOnBoard,
  isChatContainer = false,
  isAnswerContainer = false,
  handleDeleteManyBeneficiaries = () => {}
}) => {
  const { user } = useSelector(state => state.app.user);

  const [sectorModalIsOpen, setSectorModalIsOpen] = useState(false)
  const [messageModalIsOpen, setMessageModalIsOpen] = useState(false)
  const [modalNewsIsOpen, setModalNewsIsOpen] = useState(false)
  const [modalFormIsOpen, setModalFormIsOpen] = useState(false)
  const [modalTermsIsOpen, setModalTermsIsOpen] = useState(false)
  const [modalMagicLinkIsOpen, setModalMagicLinkIsOpen] = useState(false)
  const [openAssistanceRecord, setOpenAssistanceRecord] = useState(false)

  const { exportUsers, loadingExport } = exportUsersProject(selectedsUsers, "users_data_all_")

  const { isActive, setIsActive, ref } = clickOutSideHook(false)

  const handleMenuOpen = () => {
    setIsActive(!isActive)
  }

  const generateMenuItem = (label, onClick) => {
    return {
      label,
      onClick,
    }
  }

  useEffect(() => {
    if (!loadingExport && isActive) {
      handleMenuOpen()
    }
  }, [loadingExport])

  const userIds =  getIds(selectedsUsers, 'id');

  const openModalAlert = () => {
    if(selectedsUsers.length <= 100) {
      ModalAlert.danger({
        title: "Excluir Beneficiário(s)",
        text: `Você deseja mesmo excluir ${selectedsUsers?.length} beneficiário(s)`,
        confirmLabel: "Sim",
        onConfirm: () => handleDeleteManyBeneficiaries(userIds)
      })
    }
    else {
      ModalAlert.danger({
        title: "Excluir Beneficiário(s)",
        text: `Você pode selecionar até 100 beneficiário(s) por vez`,
        confirmLabel: "Ok",
        onConfirm: () => {}
      })
    }
  }

  const menuList = [
    //!isChatContainer && generateMenuItem("Excluir usuários", () => openModalAlert()),
    generateMenuItem("Enviar Mensagem", () => setMessageModalIsOpen(true)),
    generateMenuItem("Enviar Conteúdo", () => setModalNewsIsOpen(true)),
    selectedsUsers[0] && selectedsUsers[0]?.questions && generateMenuItem("Enviar Formulário", () => setModalFormIsOpen(true)),
    generateMenuItem("Agendamento de atendimento", () => setSectorModalIsOpen(true)),
    selectedsUsers?.length === 1 && generateMenuItem("Registro de Atendimento", () => setOpenAssistanceRecord(true)),
    generateMenuItem("Enviar Formulário", () => setModalTermsIsOpen(true)),
    // generateMenuItem("Enviar Link Mágico", () => setModalMagicLinkIsOpen(true)),
    user && user.roles.role === "USER_ADMIN" && generateMenuItem(`${loadingExport ? "Exportando..." : "Exportar Usuários"}`, () =>
      exportUsers(),
    ),
  ].filter(Boolean)

  return (
    <>
      <DropDownOptionsButton
        {...{
          menuOptions: menuList,
          ref,
          isActive,
          handleMenuOpen,
          colorButton: "orange",
          labelButton: `Ações ${countUsers || ""}`,
          isDisabled: !selectedsUsers.length,
        }}
      />

      {sectorModalIsOpen && (
        <SectorAutomationContainer
          isChatContainer={isChatContainer}
          selectedsUsers={selectedsUsers || selectedCardOnBoard}
          setSectorModalIsOpen={setSectorModalIsOpen}
          sectorModalIsOpen={sectorModalIsOpen}
          //closeModalActions={closeModal}
        />
      )}

      {openAssistanceRecord && (
        <AssistanceRecordContainer 
          handleCloseModal={setOpenAssistanceRecord}
          selectedsUsers={selectedsUsers}/>
      )}
      
      {messageModalIsOpen && (
        <MessageContainer
          isChatContainer={isChatContainer}
          setMessageModalIsOpen={setMessageModalIsOpen}
          messageModalIsOpen={messageModalIsOpen}
          selectedsUsers={selectedsUsers || selectedCardOnBoard}
        />
      )}
      {modalNewsIsOpen && (
        <MessageNewsContainer
          selectedsUsers={selectedsUsers || selectedCardOnBoard}
          setModalNewsIsOpen={setModalNewsIsOpen}
          modalNewsIsOpen={modalNewsIsOpen}
        />
      )}
      {modalTermsIsOpen && (
        <SendTermsOfUseContainer
          modalTermsIsOpen={modalTermsIsOpen}
          setModalTermsIsOpen={setModalTermsIsOpen}
          isChatContainer={isChatContainer}
          selectedUsers={selectedsUsers || selectedCardOnBoard}
        />
      )}
      {modalMagicLinkIsOpen && (
        <SendMagicLinkContainer
          setModalMagicLinkIsOpen={setModalMagicLinkIsOpen}
          modalMagicLinkIsOpen={modalMagicLinkIsOpen}
          selectedsUsers={selectedsUsers || selectedCardOnBoard}
        />
      )}
      {(modalFormIsOpen) && (
        <SendFormContainer
          handleCloseModal={() => setModalFormIsOpen(false)}
          selectedUsers={selectedsUsers || selectedCardOnBoard}
          modalIsOpen={modalFormIsOpen}
        />
      )}
    </>
  )
}
